import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { OrgContext } from '../context/OrgContext';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  // When browsing inside an /o/:slug context, the footer's brand + "Home"
  // link should NOT navigate to the platform landing — customers of that
  // org shouldn't be able to click through to the platform home page.
  const inOrgContext = /^\/o\/[^/]+/.test(useLocation().pathname);
  // The external ez11.com links stay visible inside an org too, unless the org
  // is white-label. Defensive read: the footer also renders outside OrgProvider.
  const org = useContext(OrgContext)?.org;
  const showPoweredBy = !org?.hidePoweredBy;

  return (
    <footer className="eez7-footer">
      <div className="eez7-footer-inner">
        <div className="eez7-footer-grid">
          <div className="eez7-footer-brand-col">
            {inOrgContext ? (
              <span className="eez7-footer-brand" aria-label="EZ11">
                <span className="eez7-footer-logo">ez11</span>
              </span>
            ) : (
              <Link to="/" className="eez7-footer-brand" aria-label="EZ11 home">
                <span className="eez7-footer-logo">ez11</span>
              </Link>
            )}
            <p className="eez7-footer-tag">Book. Manage. More.</p>
          </div>

          <div className="eez7-footer-col">
            <h4 className="eez7-footer-heading">Contact</h4>
            <ul className="eez7-footer-list">
              <li>
                <a href="mailto:hello@ez11.com">
                  <i className="bi bi-envelope" /> hello@ez11.com
                </a>
              </li>
              <li>
                <span>
                  <i className="bi bi-geo-alt" /> Heliopolis, Cairo, Egypt
                </span>
              </li>
            </ul>
          </div>

          <div className="eez7-footer-col">
            <h4 className="eez7-footer-heading">Company</h4>
            <ul className="eez7-footer-list">
              {/* Hide the "Home" link when the guest is inside an org
                  widget — they should stay within the org's flow. The external
                  "About ez11" link stays (new tab) unless the org is white-label. */}
              {!inOrgContext && <li><Link to="/">Home</Link></li>}
              {showPoweredBy && <li><a href="https://ez11.com" target="_blank" rel="noopener">About ez11</a></li>}
              <li><a href="mailto:hello@ez11.com">Support</a></li>
            </ul>
          </div>
        </div>

        <div className="eez7-footer-bottom">
          <p>
            &copy; {currentYear} EZ11. All rights reserved.
            {/* Company site link (helps ez11.com in search). Shown inside an
                org's pages too (opens in a new tab); hidden for white-label orgs. */}
            {showPoweredBy && (
              <>
                {' '}· An <a href="https://ez11.com" target="_blank" rel="noopener">ez11</a> product
              </>
            )}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
